import React from 'react';
import TableIcon from './TableIcon';

const TableRow = ({ hasThreePack, content }) => {
    const { title, content: text } = content;
    let { included } = content
    if (!hasThreePack) {
        included=[included[0], included[1]]
    }
    return (
        <div className="tableRow">
            <div className={`tableRow-content-container ${hasThreePack ? "three-packs" : ""}`}>  
                <h5 className="tableRow-content-title">{title}</h5>
                <p className="tableRow-content-text"dangerouslySetInnerHTML={{__html: text}} />
            </div>
            {included.map((option, index) => {
            // Get random Key for map
            const key = Math.ceil(Math.random() * 10);
                return <TableIcon hasThreePack={hasThreePack} isIncluded={option} key={`${index}-${key}`} />;
            })}
        </div>
    );
};

export default TableRow;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/TableRow.js